
  import ipxStaticRuntime$_451IJ1OnDcqb8GUA_VwHBJtq_7iYRd3Earnor9L8vxn0 from 'C:/Users/BenjaminGrand/Documents/live-display/node_modules/.pnpm/@nuxt+image@2.0.0_db0@0.4.1_ioredis@5.10.1_magicast@0.5.2/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"ipxStatic"} */
    provider: "ipxStatic",
    providers: {
        ['ipxStatic']: { setup: ipxStaticRuntime$_451IJ1OnDcqb8GUA_VwHBJtq_7iYRd3Earnor9L8vxn0, defaults: {} }
    }
  }
